import fileConstants from 'constants/files';

const getAiFilePlagLink = (file = {}, flagFiles = []) => {
  const {
    ai_plagreport_id: plagreportId, ai_plag_level: plagLevel = 0,
    override_pgch: overridePgch, ai_plag_status: plagStatus = null,
  } = file;

  if (plagStatus !== 'found') return null;
  if (!plagreportId) return null;
  if (overridePgch) return null;
  if (!flagFiles || !flagFiles.length) return null;
  if (plagLevel < fileConstants.MAX_AI_PLAG_PERCENT) return null;

  const findPlagFile = flagFiles.find(plagFile => plagFile._id === plagreportId);

  if (!findPlagFile) return null;

  return findPlagFile.location;
};

export default getAiFilePlagLink;
